import script from "./MusicAccessControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./MusicAccessControl.vue?vue&type=script&setup=true&lang=ts"

import "./MusicAccessControl.vue?vue&type=style&index=0&id=a5cdd1d6&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5cdd1d6"]])

export default __exports__